var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-console */
import { call, put, all } from 'redux-saga/effects';
import { batchActions } from 'redux-batched-actions';
import { loadMenuRequest } from '../../../api/load-menu';
import { loadMenuFromFileRequest } from '../../../api/load-menu-from-file';
import { setMenuAction, setLoadingStartAction, setLoadingStopAction, setProductsAction, } from '../../actions';
import { loadAndInjectMenuProducts } from '../../../utils/load-and-inject';
import { getUpdatedFullMenu } from '../navigate-to-route/_utils/get-updated-full-menu';
import { getMenuProductsToList } from '../../_utils/get-menu-products-to-list';
import { getResultMappedMenu } from './_utils/get-result-mapped-menu';
import { getNavigateCallback } from './_utils/get-navigate-callback';
import { DEFAULT_LOAD_MENU_REQUEST_ENDPOINT, ROOT_APP_NAMESPACE, } from './constants';
import { getFilteredMenuList } from './_utils/get-filtered-menu-list';
import { getParsedError } from './_utils/get-parsed-error';
import { findCurrentRoute, getRoutesWithoutInlinedConfig, } from './_utils/get-routes';
import { loadBuggyRoutes } from './_utils/load-buggy-routes';
import { mergeMenuWithPermissions } from './_utils/merge-menu-with-permissions';
var DEFAULT_REQUEST_CONFIGS = {
    loadMenuRequestEndpoint: DEFAULT_LOAD_MENU_REQUEST_ENDPOINT,
    appNamespace: ROOT_APP_NAMESPACE,
};
export function fetchProductsWorkerSaga(_a) {
    var externalPackages, menuRequest, _b, data, error, errorText, headers, menuItems, formattedData, flattenMenuProductsList, currentRoute, filteredFlattenMenuList, injectedProducts, completeMenuConfig, updatedFullFlattenedMenu, routeParams, onNavigateCallback, routesWithoutConfig, error_1, errorData;
    var dispatch = _a.dispatch, loadModuleFunction = _a.loadModuleFunction, router = _a.router, callbackFinallyLoad = _a.callbackFinallyLoad, navigateAfterLoadConfig = _a.navigateAfterLoadConfig, withoutLoadingIndicator = _a.withoutLoadingIndicator, loadAllModules = _a.loadAllModules, _c = _a.routeUrl, routeUrl = _c === void 0 ? window.location.pathname : _c, _d = _a.configs, _e = _d === void 0 ? DEFAULT_REQUEST_CONFIGS : _d, loadMenuRequestEndpoint = _e.loadMenuRequestEndpoint, appNamespace = _e.appNamespace, browserCacheParams = _e.browserCacheParams, menuFromFileRequest = _e.menuFromFileRequest, defaultShown = _e.defaultShown, excludeEndpoinds = _a.excludeEndpoinds, 
    // доп конфиг для меню поступает из переменных окружения при установке саги
    _f = _a.additionalProductsData, 
    // доп конфиг для меню поступает из переменных окружения при установке саги
    additionalProductsData = _f === void 0 ? [] : _f, errorAction = _a.errorAction, errorActionsArray = _a.errorActionsArray, successAction = _a.successAction, successActionsArray = _a.successActionsArray, callbackOnError = _a.callbackOnError, callbackOnSuccess = _a.callbackOnSuccess, noRetry = _a.noRetry, store = _a.store, permissions = _a.permissions;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                externalPackages = (store.getDependencies() || {}).externalPackages;
                if (!!withoutLoadingIndicator) return [3 /*break*/, 2];
                return [4 /*yield*/, put(setLoadingStartAction())];
            case 1:
                _g.sent();
                _g.label = 2;
            case 2:
                menuRequest = menuFromFileRequest
                    ? loadMenuFromFileRequest
                    : loadMenuRequest;
                _g.label = 3;
            case 3:
                _g.trys.push([3, 19, , 27]);
                return [4 /*yield*/, call(menuRequest, {
                        appNamespace: appNamespace,
                        endpoint: loadMenuRequestEndpoint,
                        noRetry: noRetry,
                        browserCacheParams: browserCacheParams,
                    })];
            case 4:
                _b = _g.sent(), data = _b.data, error = _b.error, errorText = _b.errorText, headers = _b.headers;
                menuItems = menuFromFileRequest ? data : data.menu;
                console.log('[fetchProductsWorkerSaga]: menuFromFileRequest', menuFromFileRequest);
                formattedData = permissions && menuFromFileRequest
                    ? mergeMenuWithPermissions({ menuItems: menuItems, permissions: permissions, defaultShown: defaultShown })
                    : menuItems;
                if (permissions && menuFromFileRequest) {
                    console.log('[fetchProductsWorkerSaga]: menuItems', menuItems);
                    console.log('[fetchProductsWorkerSaga]: defaultShown', defaultShown);
                    console.log('[fetchProductsWorkerSaga]: mergedMenuItems', formattedData);
                }
                if (error) {
                    throw new Error(JSON.stringify({ errorText: errorText, headers: headers }));
                }
                flattenMenuProductsList = getMenuProductsToList({
                    menu: formattedData,
                });
                console.log('[fetchProductsWorkerSaga]: flattenMenuProductsList', flattenMenuProductsList);
                currentRoute = findCurrentRoute({
                    flattenMenuProductsList: flattenMenuProductsList,
                    routeUrl: routeUrl,
                });
                console.log('[fetchProductsWorkerSaga]: currentRoute', currentRoute);
                filteredFlattenMenuList = loadAllModules
                    ? flattenMenuProductsList
                    : getFilteredMenuList({
                        flattenMenuProductsList: flattenMenuProductsList,
                        additionalProductsData: additionalProductsData,
                        routeUrl: routeUrl,
                        excludeEndpoinds: excludeEndpoinds,
                        currentRoute: currentRoute,
                    });
                console.log('[fetchProductsWorkerSaga]: filteredFlattenMenuList', filteredFlattenMenuList);
                return [4 /*yield*/, call(loadAndInjectMenuProducts, {
                        menuProducts: filteredFlattenMenuList,
                        loadModuleFunction: loadModuleFunction,
                        router: router,
                        disableFetchI18n: true,
                        externalPackages: externalPackages,
                    })];
            case 5:
                injectedProducts = _g.sent();
                console.log('[fetchProductsWorkerSaga]: injectedProducts', injectedProducts);
                completeMenuConfig = getResultMappedMenu({
                    responseMenuData: formattedData,
                    injectedProducts: injectedProducts,
                    additionalProductsData: additionalProductsData,
                    router: router,
                    fullFlattenMenuProductsList: flattenMenuProductsList,
                });
                updatedFullFlattenedMenu = getUpdatedFullMenu({
                    loadedItems: injectedProducts,
                    fullMenu: flattenMenuProductsList,
                });
                console.log('[fetchProductsWorkerSaga]: completeMenuConfig', completeMenuConfig);
                console.log('[fetchProductsWorkerSaga]: updatedFullFlattenedMenu', updatedFullFlattenedMenu);
                // установка меню
                return [4 /*yield*/, put(batchActions([
                        setMenuAction({ menu: completeMenuConfig }),
                        setProductsAction({ products: updatedFullFlattenedMenu }),
                    ]))];
            case 6:
                // установка меню
                _g.sent();
                if (!successAction) return [3 /*break*/, 8];
                return [4 /*yield*/, put(successAction())];
            case 7:
                _g.sent();
                return [3 /*break*/, 10];
            case 8:
                if (!successActionsArray) return [3 /*break*/, 10];
                return [4 /*yield*/, all(successActionsArray.map(function (action) { return put(action()); }))];
            case 9:
                _g.sent();
                _g.label = 10;
            case 10:
                if (!callbackOnSuccess) return [3 /*break*/, 12];
                return [4 /*yield*/, callbackOnSuccess({})];
            case 11:
                _g.sent();
                _g.label = 12;
            case 12:
                if (!navigateAfterLoadConfig) return [3 /*break*/, 13];
                routeParams = navigateAfterLoadConfig.routeParams || {};
                onNavigateCallback = getNavigateCallback({
                    callbackFinallyLoad: callbackFinallyLoad,
                    dispatch: dispatch,
                    setLoadingStopAction: setLoadingStopAction,
                });
                router.navigate(navigateAfterLoadConfig.routeName, routeParams, onNavigateCallback);
                return [3 /*break*/, 16];
            case 13:
                if (!callbackFinallyLoad) return [3 /*break*/, 14];
                callbackFinallyLoad({ loadProductsStopAction: setLoadingStopAction });
                return [3 /*break*/, 16];
            case 14: return [4 /*yield*/, put(setLoadingStopAction())];
            case 15:
                _g.sent();
                _g.label = 16;
            case 16:
                routesWithoutConfig = getRoutesWithoutInlinedConfig(updatedFullFlattenedMenu);
                console.log('[fetchProductsWorkerSaga]: routesWithoutConfig', routesWithoutConfig);
                if (!(routesWithoutConfig.length && currentRoute && currentRoute.staticURL)) return [3 /*break*/, 18];
                return [4 /*yield*/, call(loadBuggyRoutes, {
                        dispatch: dispatch,
                        updatedFullFlattenedMenu: updatedFullFlattenedMenu,
                        completeMenuConfig: completeMenuConfig,
                        externalPackages: externalPackages,
                        loadModuleFunction: loadModuleFunction,
                        router: router,
                        routesWithoutConfig: routesWithoutConfig,
                    })];
            case 17:
                _g.sent();
                _g.label = 18;
            case 18: return [3 /*break*/, 27];
            case 19:
                error_1 = _g.sent();
                console.error('fetchProductsWorkerSaga get an error', error_1.message);
                errorData = getParsedError({
                    sagaName: 'fetchProductsWorkerSaga',
                    error: error_1,
                });
                if (!callbackOnError) return [3 /*break*/, 20];
                callbackOnError({
                    loadProductsStopAction: setLoadingStopAction,
                    errorData: typeof errorData === 'object'
                        ? errorData
                        : { errorText: '', headers: {} },
                });
                return [3 /*break*/, 22];
            case 20:
                if (!!withoutLoadingIndicator) return [3 /*break*/, 22];
                return [4 /*yield*/, put(setLoadingStopAction())];
            case 21:
                _g.sent();
                _g.label = 22;
            case 22:
                if (callbackFinallyLoad) {
                    callbackFinallyLoad({
                        loadProductsStopAction: setLoadingStopAction,
                    });
                }
                if (!errorAction) return [3 /*break*/, 24];
                return [4 /*yield*/, put(errorAction())];
            case 23:
                _g.sent();
                return [3 /*break*/, 26];
            case 24:
                if (!errorActionsArray) return [3 /*break*/, 26];
                return [4 /*yield*/, all(errorActionsArray.map(function (action) { return put(action()); }))];
            case 25:
                _g.sent();
                _g.label = 26;
            case 26: return [3 /*break*/, 27];
            case 27: return [2 /*return*/];
        }
    });
}
